var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-toolbar" },
    [
      _c("KanbanSummary", {
        attrs: {
          records: _vm.records,
          selectedField: _vm.currentField,
          kanbanField: _vm.kanbanField,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar-actions" },
        [
          _c("CustomPicker", {
            staticClass: "kanban-field-selector",
            attrs: {
              items: _vm.fields,
              idKey: "_id",
              labelKey: "name",
              title: "Select a field",
              icon: "view_week",
            },
            on: { input: _vm.handleFieldChange },
            model: {
              value: _vm.currentField,
              callback: function ($$v) {
                _vm.currentField = $$v
              },
              expression: "currentField",
            },
          }),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { type: "primary", ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("open-settings")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("settings")]),
              _vm._v(" "),
              _c("span", [_vm._v("Kanban Settings")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }